
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.9 20A9 9 0 104 16.1L2 22z"}}),_c('path',{attrs:{"d":"M9.4 8.6c-.2 0-.5.1-.7.3-.3.3-.8.8-.8 1.9s.8 2.2.9 2.4c.1.2 1.6 2.6 4 3.6.6.2 1 .4 1.4.3.5-.1 1.3-.5 1.4-1.1.2-.5.2-1 .1-1.1-.1-.1-.3-.2-.5-.3-.3-.2-1.3-.6-1.5-.7-.2-.1-.3-.1-.5.1-.1.2-.5.6-.6.8-.1.1-.2.1-.5 0s-1-.4-1.8-1.1c-.7-.6-1.1-1.3-1.3-1.6-.1-.2 0-.3.1-.4l.4-.4c.1-.2.2-.3.2-.5.1-.1 0-.3 0-.4 0-.1-.5-1.2-.6-1.6-.2-.4-.3-.4-.5-.4z"}})])
          )
        }
      }
    